/**
 * Typed mirror of the CSS custom properties in tokens.css.
 *
 * GENERATED FILE — do not edit by hand. Run `npm run tokens`.
 *
 * Prefer plain CSS (`var(--text-primary)`) in stylesheets. Use this only where a
 * token has to cross into JS — inline styles, canvas, chart libraries.
 */

export const token = {
  'core-color-white': 'var(--core-color-white)',
  'core-color-gray-25': 'var(--core-color-gray-25)',
  'core-color-gray-50': 'var(--core-color-gray-50)',
  'core-color-gray-100': 'var(--core-color-gray-100)',
  'core-color-gray-200': 'var(--core-color-gray-200)',
  'core-color-gray-300': 'var(--core-color-gray-300)',
  'core-color-gray-400': 'var(--core-color-gray-400)',
  'core-color-gray-500': 'var(--core-color-gray-500)',
  'core-color-gray-600': 'var(--core-color-gray-600)',
  'core-color-gray-700': 'var(--core-color-gray-700)',
  'core-color-gray-800': 'var(--core-color-gray-800)',
  'core-color-gray-900': 'var(--core-color-gray-900)',
  'core-color-gray-950': 'var(--core-color-gray-950)',
  'core-color-blue-50': 'var(--core-color-blue-50)',
  'core-color-blue-200': 'var(--core-color-blue-200)',
  'core-color-blue-500': 'var(--core-color-blue-500)',
  'core-color-blue-700': 'var(--core-color-blue-700)',
  'core-color-green-50': 'var(--core-color-green-50)',
  'core-color-green-200': 'var(--core-color-green-200)',
  'core-color-green-500': 'var(--core-color-green-500)',
  'core-color-green-700': 'var(--core-color-green-700)',
  'core-color-red-50': 'var(--core-color-red-50)',
  'core-color-red-200': 'var(--core-color-red-200)',
  'core-color-red-500': 'var(--core-color-red-500)',
  'core-color-red-700': 'var(--core-color-red-700)',
  'core-color-black': 'var(--core-color-black)',
  'core-color-teal-500': 'var(--core-color-teal-500)',
  'core-color-yellow-700': 'var(--core-color-yellow-700)',
  'core-color-yellow-500': 'var(--core-color-yellow-500)',
  'core-color-yellow-200': 'var(--core-color-yellow-200)',
  'core-color-yellow-50': 'var(--core-color-yellow-50)',
  'core-color-transparent': 'var(--core-color-transparent)',
  'core-color-blue-100': 'var(--core-color-blue-100)',
  'core-color-ocean-300': 'var(--core-color-ocean-300)',
  'core-color-ocean-400': 'var(--core-color-ocean-400)',
  'core-color-ocean-500': 'var(--core-color-ocean-500)',
  'core-color-ocean-600': 'var(--core-color-ocean-600)',
  'core-color-blue-25': 'var(--core-color-blue-25)',
  'text-primary': 'var(--text-primary)',
  'text-secondary': 'var(--text-secondary)',
  'text-tertiary': 'var(--text-tertiary)',
  'text-placeholder': 'var(--text-placeholder)',
  'button-primary-text': 'var(--button-primary-text)',
  'text-link': 'var(--text-link)',
  'text-success': 'var(--text-success)',
  'text-error': 'var(--text-error)',
  'icon-primary': 'var(--icon-primary)',
  'icon-secondary': 'var(--icon-secondary)',
  'icon-disabled': 'var(--icon-disabled)',
  'icon-success': 'var(--icon-success)',
  'icon-error': 'var(--icon-error)',
  'surface-background': 'var(--surface-background)',
  'border-primary': 'var(--border-primary)',
  'border-secondary': 'var(--border-secondary)',
  'border-label': 'var(--border-label)',
  'border-success': 'var(--border-success)',
  'border-error': 'var(--border-error)',
  'border-info': 'var(--border-info)',
  'button-secondary-text': 'var(--button-secondary-text)',
  'button-primary-surface': 'var(--button-primary-surface)',
  'button-secondary-surface': 'var(--button-secondary-surface)',
  'surface-card': 'var(--surface-card)',
  'text-inverse': 'var(--text-inverse)',
  'chart-14': 'var(--chart-14)',
  'chart-8': 'var(--chart-8)',
  'chart-7': 'var(--chart-7)',
  'chart-9': 'var(--chart-9)',
  'chart-6': 'var(--chart-6)',
  'chart-10': 'var(--chart-10)',
  'chart-4': 'var(--chart-4)',
  'chart-2': 'var(--chart-2)',
  'chart-12': 'var(--chart-12)',
  'chart-5': 'var(--chart-5)',
  'chart-1': 'var(--chart-1)',
  'chart-13': 'var(--chart-13)',
  'chart-11': 'var(--chart-11)',
  'chart-3': 'var(--chart-3)',
  'sidebar-item-surface-hover': 'var(--sidebar-item-surface-hover)',
  'sidebar-item-surface-active': 'var(--sidebar-item-surface-active)',
  'sidebar-surface': 'var(--sidebar-surface)',
  'badge-info-surface': 'var(--badge-info-surface)',
  'badge-error-surface': 'var(--badge-error-surface)',
  'badge-success-surface': 'var(--badge-success-surface)',
  'badge-gray-surface': 'var(--badge-gray-surface)',
  'chip-surface': 'var(--chip-surface)',
  'chip-surface-hover': 'var(--chip-surface-hover)',
  'icon-info': 'var(--icon-info)',
  'sidebar-item-surface': 'var(--sidebar-item-surface)',
  'text-link-hover': 'var(--text-link-hover)',
  'border-disabled': 'var(--border-disabled)',
  'sidebar-menu-item-surface': 'var(--sidebar-menu-item-surface)',
  'sidebar-menu-item-surface-hover': 'var(--sidebar-menu-item-surface-hover)',
  'icon-inverse': 'var(--icon-inverse)',
  'icon-info-hover': 'var(--icon-info-hover)',
  'button-tertiary-text': 'var(--button-tertiary-text)',
  'button-tertiary-surface': 'var(--button-tertiary-surface)',
  'button-primary-surface-hover': 'var(--button-primary-surface-hover)',
  'button-secondary-surface-hover': 'var(--button-secondary-surface-hover)',
  'button-tertiary-surface-hover': 'var(--button-tertiary-surface-hover)',
  'button-primary-surface-disabled': 'var(--button-primary-surface-disabled)',
  'button-secondary-surface-disabled': 'var(--button-secondary-surface-disabled)',
  'button-tertiary-surface-disabled': 'var(--button-tertiary-surface-disabled)',
  'text-disabled': 'var(--text-disabled)',
  'button-ghost-surface-hover': 'var(--button-ghost-surface-hover)',
  'button-ghost-text': 'var(--button-ghost-text)',
  'chip-surface-open': 'var(--chip-surface-open)',
  'chip-item-surface-hover': 'var(--chip-item-surface-hover)',
  'select-surface': 'var(--select-surface)',
  'select-surface-disabled': 'var(--select-surface-disabled)',
  'select-border': 'var(--select-border)',
  'select-border-active': 'var(--select-border-active)',
  'select-item-surface': 'var(--select-item-surface)',
  'select-item-surface-disabled': 'var(--select-item-surface-disabled)',
  'select-item-surface-hover': 'var(--select-item-surface-hover)',
  'select-border-disabled': 'var(--select-border-disabled)',
  'checkbox-border': 'var(--checkbox-border)',
  'checkbox-surface-disabled': 'var(--checkbox-surface-disabled)',
  'checkbox-surface-hover': 'var(--checkbox-surface-hover)',
  'checkbox-surface': 'var(--checkbox-surface)',
  'checkbox-surface-selected': 'var(--checkbox-surface-selected)',
  'checkbox-surface-selected-hover': 'var(--checkbox-surface-selected-hover)',
  'select-item-surface-active': 'var(--select-item-surface-active)',
  'calendar-cell-surface': 'var(--calendar-cell-surface)',
  'calendar-cell-surface-hover': 'var(--calendar-cell-surface-hover)',
  'calendar-cell-surface-disabled': 'var(--calendar-cell-surface-disabled)',
  'calendar-cell-surface-active': 'var(--calendar-cell-surface-active)',
  'calendar-cell-surface-active-hover': 'var(--calendar-cell-surface-active-hover)',
  'calendar-cell-surface-active-disabled': 'var(--calendar-cell-surface-active-disabled)',
  'calendar-cell-surface-selected': 'var(--calendar-cell-surface-selected)',
  'calendar-cell-surface-selected-hover': 'var(--calendar-cell-surface-selected-hover)',
  'calendar-cell-surface-selected-disabled': 'var(--calendar-cell-surface-selected-disabled)',
  'calendar-cell-connector-surface': 'var(--calendar-cell-connector-surface)',
  'calendar-list-item-surface': 'var(--calendar-list-item-surface)',
  'calendar-list-item-surface-hover': 'var(--calendar-list-item-surface-hover)',
  'calendar-list-item-surface-active': 'var(--calendar-list-item-surface-active)',
  'button-ghost-neutral-text': 'var(--button-ghost-neutral-text)',
  'button-ghost-neutral-surface-hover': 'var(--button-ghost-neutral-surface-hover)',
  'surface-tertiary': 'var(--surface-tertiary)',
  'surface-neutral-subtle': 'var(--surface-neutral-subtle)',
  'surface-info-subtle': 'var(--surface-info-subtle)',
  'surface-success-subtle': 'var(--surface-success-subtle)',
  'surface-error-subtle': 'var(--surface-error-subtle)',
  'surface-warning-subtle': 'var(--surface-warning-subtle)',
  'surface-inverse': 'var(--surface-inverse)',
  'text-warning': 'var(--text-warning)',
  'text-brand': 'var(--text-brand)',
  'icon-warning': 'var(--icon-warning)',
  'border-warning': 'var(--border-warning)',
  'border-focus': 'var(--border-focus)',
  'surface-scrim': 'var(--surface-scrim)',
  'scroll-surface': 'var(--scroll-surface)',
  'chip-surface-selected': 'var(--chip-surface-selected)',
  'chip-surface-selected-hover': 'var(--chip-surface-selected-hover)',
  'chip-surface-selected-open': 'var(--chip-surface-selected-open)',
  'toggle-surface': 'var(--toggle-surface)',
  'toggle-surface-selected': 'var(--toggle-surface-selected)',
  'toggle-surface-selected-hover': 'var(--toggle-surface-selected-hover)',
  'toggle-surface-selected-disabled': 'var(--toggle-surface-selected-disabled)',
  'toggle-surface-hover': 'var(--toggle-surface-hover)',
  'toggle-surface-disabled': 'var(--toggle-surface-disabled)',
  'toggle-button-surface': 'var(--toggle-button-surface)',
  'table-header-surface': 'var(--table-header-surface)',
  'table-cell-surface': 'var(--table-cell-surface)',
  'table-cell-surface-hover': 'var(--table-cell-surface-hover)',
  'pagination-surface-default': 'var(--pagination-surface-default)',
  'pagination-surface-hover': 'var(--pagination-surface-hover)',
  'pagination-surface-disabled': 'var(--pagination-surface-disabled)',
  'badge-neutral-surface': 'var(--badge-neutral-surface)',
  'table-surface': 'var(--table-surface)',
  'progress-positive-surface': 'var(--progress-positive-surface)',
  'progress-negative-surface': 'var(--progress-negative-surface)',
  'progress-neutral-surface': 'var(--progress-neutral-surface)',
  'progress-surface': 'var(--progress-surface)',
  'loader-dot': 'var(--loader-dot)',
  'loader-dot-gradient-start': 'var(--loader-dot-gradient-start)',
  'loader-dot-gradient-mid': 'var(--loader-dot-gradient-mid)',
  'loader-dot-gradient-end': 'var(--loader-dot-gradient-end)',
  'loader-dot-glow': 'var(--loader-dot-glow)',
  'chart-axis-labels': 'var(--chart-axis-labels)',
  'chart-legend': 'var(--chart-legend)',
  'chart-grid': 'var(--chart-grid)',
  'chart-15': 'var(--chart-15)',
  'chart-brand-grameenphone': 'var(--chart-brand-grameenphone)',
  'chart-brand-robi': 'var(--chart-brand-robi)',
  'chart-brand-airtel': 'var(--chart-brand-airtel)',
  'chart-brand-banglalink': 'var(--chart-brand-banglalink)',
  'chart-brand-teletalk': 'var(--chart-brand-teletalk)',
  'chart-brand-skitto': 'var(--chart-brand-skitto)',
  'chart-brand-ryze': 'var(--chart-brand-ryze)',
  'chart-brand-cirkle': 'var(--chart-brand-cirkle)',
  'chip-counter-surface': 'var(--chip-counter-surface)',
  'tabs-surface-selected-hover': 'var(--tabs-surface-selected-hover)',
  'tabs-surface-selected': 'var(--tabs-surface-selected)',
  'tabs-surface-hover': 'var(--tabs-surface-hover)',
  'tabs-surface': 'var(--tabs-surface)',
  'text-inverse-secondary': 'var(--text-inverse-secondary)',
  'input-border-disabled': 'var(--input-border-disabled)',
  'input-border': 'var(--input-border)',
  'input-border-active': 'var(--input-border-active)',
  'input-surface-disabled': 'var(--input-surface-disabled)',
  'input-surface': 'var(--input-surface)',
  'input-border-error': 'var(--input-border-error)',
  'chart-reference': 'var(--chart-reference)',
  'loading-state-dot-accent': 'var(--loading-state-dot-accent)',
  'search-border-active': 'var(--search-border-active)',
  'search-border-disabled': 'var(--search-border-disabled)',
  'search-border': 'var(--search-border)',
  'search-surface-disabled': 'var(--search-surface-disabled)',
  'search-surface': 'var(--search-surface)',
  'search-surface-hover': 'var(--search-surface-hover)',
  'surface-placeholder': 'var(--surface-placeholder)',
  'button-destructive-surface': 'var(--button-destructive-surface)',
  'button-destructive-surface-hover': 'var(--button-destructive-surface-hover)',
  'button-destructive-surface-disabled': 'var(--button-destructive-surface-disabled)',
  'button-destructive-text': 'var(--button-destructive-text)',
  'overlay-surface': 'var(--overlay-surface)',
  'composer-glow': 'var(--composer-glow)',
  'composer-glow-success': 'var(--composer-glow-success)',
  'chat-row-surface-hover': 'var(--chat-row-surface-hover)',
  'tooltip-surface': 'var(--tooltip-surface)',
  'tabs-background': 'var(--tabs-background)',
  'progress-ai-surface': 'var(--progress-ai-surface)',
  'glass-surface': 'var(--glass-surface)',
  'radius-md': 'var(--radius-md)',
  'radius-xl': 'var(--radius-xl)',
  'radius-xs': 'var(--radius-xs)',
  'radius-lg': 'var(--radius-lg)',
  'radius-none': 'var(--radius-none)',
  'radius-2xl': 'var(--radius-2xl)',
  'radius-sm': 'var(--radius-sm)',
  'radius-full': 'var(--radius-full)',
  'radius-xxs': 'var(--radius-xxs)',
  'space-32': 'var(--space-32)',
  'space-12': 'var(--space-12)',
  'space-16': 'var(--space-16)',
  'space-6': 'var(--space-6)',
  'space-8': 'var(--space-8)',
  'space-4': 'var(--space-4)',
  'space-96': 'var(--space-96)',
  'space-128': 'var(--space-128)',
  'space-24': 'var(--space-24)',
  'space-0': 'var(--space-0)',
  'space-64': 'var(--space-64)',
  'space-2': 'var(--space-2)',
  'space-48': 'var(--space-48)',
  'space-80': 'var(--space-80)',
  'space-20': 'var(--space-20)',
  'space-40': 'var(--space-40)',
  'space-52': 'var(--space-52)',
  'space-1': 'var(--space-1)',
  'space-3': 'var(--space-3)',
  'space-180': 'var(--space-180)',
  'space-108': 'var(--space-108)',
  'font-family-sans': 'var(--font-family-sans)',
  'font-weight-semibold': 'var(--font-weight-semibold)',
  'font-weight-medium': 'var(--font-weight-medium)',
  'font-weight-regular': 'var(--font-weight-regular)',
  'font-weight-bold': 'var(--font-weight-bold)',
  'font-size-display-xs': 'var(--font-size-display-xs)',
  'font-size-md': 'var(--font-size-md)',
  'font-size-lg': 'var(--font-size-lg)',
  'font-size-sm': 'var(--font-size-sm)',
  'line-height-display-xs': 'var(--line-height-display-xs)',
  'line-height-md': 'var(--line-height-md)',
  'line-height-lg': 'var(--line-height-lg)',
  'line-height-sm': 'var(--line-height-sm)',
  'letter-spacing-md': 'var(--letter-spacing-md)',
  'letter-spacing-sm': 'var(--letter-spacing-sm)',
  'font-size-xxs': 'var(--font-size-xxs)',
  'line-height-xxs': 'var(--line-height-xxs)',
  'font-size-xs': 'var(--font-size-xs)',
  'line-height-xs': 'var(--line-height-xs)',
  'letter-spacing-xs': 'var(--letter-spacing-xs)',
  'border-width-2': 'var(--border-width-2)',
  'border-width-1': 'var(--border-width-1)',
  'border-width-0': 'var(--border-width-0)',
  'shadow-color-xs': 'var(--shadow-color-xs)',
  'shadow-color-lg-01': 'var(--shadow-color-lg-01)',
  'shadow-color-lg-02': 'var(--shadow-color-lg-02)',
  'shadow-color-lg-03': 'var(--shadow-color-lg-03)',
  'background-blur-xl': 'var(--background-blur-xl)',
  'background-blur-sm': 'var(--background-blur-sm)',
  'background-blur-lg': 'var(--background-blur-lg)',
  'background-blur-md': 'var(--background-blur-md)',
  'layer-blur-glow': 'var(--layer-blur-glow)',
  'background-blur-xs': 'var(--background-blur-xs)',
  'background-blur-xxs': 'var(--background-blur-xxs)',
  'shadow-xs': 'var(--shadow-xs)',
  'shadow-sm': 'var(--shadow-sm)',
  'shadow-md': 'var(--shadow-md)',
  'shadow-lg': 'var(--shadow-lg)',
  'shadow-xl': 'var(--shadow-xl)',
} as const;

export type TokenName = keyof typeof token;

/** `tokenVar('text-primary')` -> `'var(--text-primary)'` */
export const tokenVar = (name: TokenName): string => token[name];
